import * as React from "react";
import { forwardRef, memo } from "react";

const SvgTriangleDownIcon = (props, ref) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M8.4 9.467a.5.5 0 0 1-.8 0L5.6 6.8A.5.5 0 0 1 6 6h4a.5.5 0 0 1 .4.8l-2 2.667Z"
      fill="currentColor"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTriangleDownIcon);
const Memo = memo(ForwardRef);
export default Memo;
